import type { HelpFile } from '../../types/help'
import { SystemGrantsDetailTestIds } from '../../../testids/SystemGrantsDetailTestIds'

export const systemGrantsDetailHelp: HelpFile = {
  docPage: '/docs/access-analytics/system-grants',
  texts: {
    [SystemGrantsDetailTestIds.systemGrantsDetailPage]:
      'Detail view of effective access grants on a target system, with totals and per-grant source breakdown.',
    [SystemGrantsDetailTestIds.cardTitleActiveGrants]:
      'Number of grants currently active on this system.',
    [SystemGrantsDetailTestIds.cardTitleEffectiveAccessGrants]:
      'Effective access grants on this system, broken down by identity, resource, and operation.',
    [SystemGrantsDetailTestIds.cardTitleTotalGrants]:
      'Total number of grants computed on this system, including expired and pending entries.',
    [SystemGrantsDetailTestIds.cardTitleUniqueIdentities]:
      'Number of distinct identities that hold at least one effective grant on this system.',
    [SystemGrantsDetailTestIds.colEnforcementObject]:
      'Enforcement object whose access right this grant materializes.',
    [SystemGrantsDetailTestIds.colExpand]:
      'Expand the row to see the source assignments contributing to this grant.',
    [SystemGrantsDetailTestIds.colIdentity]:
      'Identity that holds this grant.',
    [SystemGrantsDetailTestIds.colOperation]:
      'Operation permitted on the resource (read, write, execute, etc.).',
    [SystemGrantsDetailTestIds.colResource]:
      'Resource that this grant applies to.',
    [SystemGrantsDetailTestIds.colSourceAccessProfile]:
      'Access profile that contributes this grant.',
    [SystemGrantsDetailTestIds.colSourceAssignmentExpires]:
      'Expiry date of the source assignment, if any.',
    [SystemGrantsDetailTestIds.colSourceAssignmentStart]:
      'Start date of the source assignment.',
    [SystemGrantsDetailTestIds.colSourceCreatedAt]:
      'Timestamp when the source assignment was created.',
    [SystemGrantsDetailTestIds.colStatus]:
      'Current status of the grant (active, pending, expired, revoked).',
    [SystemGrantsDetailTestIds.colValidFrom]:
      'Date from which this grant is valid.',
    [SystemGrantsDetailTestIds.colValidTo]:
      'Date until which this grant is valid.',
    [SystemGrantsDetailTestIds.filterIdentity]:
      'Filter the grants list to a specific identity.',
    [SystemGrantsDetailTestIds.filterOperation]:
      'Filter the grants list by operation type.',
    [SystemGrantsDetailTestIds.linkSystemDetail]: null,
  },
}
